import React from 'react'
import { connect } from 'react-redux'
import {
  imageryAndTopographyGoogle as topoGoogle,
  imageryAndTopographyOthers as topoOthers,
  multiTile,
  multiTileLayersXYZ
} from './map-types'
import isNil from 'lodash/isNil'
import { setDownloaderOptions } from './downloader'
import { fetchVendorObjects } from '../../../action/vendor-actions'
import { activeVendorsAdd } from '../../../action/active-vendors'

class RenderLayers extends React.Component {
  constructor(props) {
    super(props)
    this.dlConfig = false
    this.getMaxZoom = this.getMaxZoom.bind(this)
  }

  getMaxZoom(layerData) {
    const { mapReference } = this.props
    let maxZoom = 18
    layerData.forEach(layer => {
      if (layer.upscaleZoomLevel) {
        maxZoom = Math.min(layer.upscaleZoomLevel - 1, maxZoom)
      } else if (layer.maxZoomLevel) {
        maxZoom = Math.min(layer.maxZoomLevel, maxZoom)
      }
    })
    mapReference.setOptions({ maxZoom })
  }

  drawOverlays() {
    const { activeLayers, activeVendors, activeVendorsAdd, fetchVendorObjects, layersDictionary, mapReference, vendors, auth } = this.props,
      layerData = activeLayers.map(id => layersDictionary[id]).filter(layer => !isNil(layer)),
      toRemove = [],
      overlays = layerData.sort((a, b) => a.drawOrder - b.drawOrder).map(layer => {
        //upscaleZoomLevel, maxZoomLevel
        if (layer.id == 81) {
          if (mapReference.mapTypeId !== 'hybrid') {
            topoGoogle(layer, mapReference)
          }
          return null
        } else if (layer.id == 891) {
          if (mapReference.mapTypeId !== 'satellite') {
            topoGoogle(layer, mapReference)
          }
          return null
        }
        else if (layer.id == 82) {
          if (mapReference.mapTypeId !== 'terrain') {
            topoGoogle(layer, mapReference)
          }
          return null
        } else if (layer.layerNodeId === 5) {
          const baseMap = mapReference.mapTypes[mapReference.mapTypeId]
          if (isNil(baseMap) || isNil(baseMap.alt) || baseMap.alt.id !== layer.id) {
            topoOthers(layer, { mapInstance: mapReference })
          }
          return null
        } else {
          if (layer.vendorId) {
            if (!vendors[layer.vendorId]) {
              fetchVendorObjects(layer)
                .then(() => {
                  activeVendorsAdd(layer.vendorId)
                })
            } else if (activeVendors.indexOf(layer.vendorId) === -1) {
              activeVendorsAdd(layer.vendorId)
            }
          }
          if (layer.cloudfrontUrl) {
            return multiTileLayersXYZ({ mapInstance: mapReference, filters: () => { return this.props.filters } }, layer)
          } else {
            return multiTile(layer, { mapInstance: mapReference, filters: () => { return this.props.filters } }, true)
          }
          // return overlayImage(layer, { mapInstance: mapReference, filters: () => { return this.props.filters } }, auth.token)
        }
      })

    this.getMaxZoom(layerData)
    mapReference.overlayMapTypes.forEach((overlay, idx) => {
      if (activeLayers.indexOf(overlay?.alt?.id) === -1) {
        toRemove.push(idx)
      }
    })
    toRemove.forEach(idx => {
      mapReference.overlayMapTypes.removeAt(idx)
    })
    overlays.filter(layer => layer !== null).forEach((overlay, idx) => {
      const renderedOverlay = mapReference.overlayMapTypes.getAt(idx)
      if (!renderedOverlay) {
        mapReference.overlayMapTypes.setAt(idx, overlay)
      } else if (renderedOverlay.alt.id !== overlay.alt.id) {
        mapReference.overlayMapTypes.insertAt(idx, overlay)
      }
    })
  }


  render() {
    if (this.props.mapReference !== null) {
      if (!this.dlConfig) {
        this.dlConfig = true
        setDownloaderOptions(this.props.mapReference)
      }
      if (this.props.selectedTab == "map") {
        this.drawOverlays()
      }
    }
    return null
  }
}

const mapStateToProps = state => ({
  activeLayers: state.userSettings.find(setting => setting.settingId === 1) ?
    state.userSettings.find(setting => setting.settingId === 1).valueArray : [],
  layersDictionary: state.layersDictionary,
  filters: state.filters,
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
  activeVendors: state.activeVendors,
  vendors: state.vendors,
  auth: state.auth,
  selectedTab: state.selectedTab
})

const mapDispatchToProps = dispatch => ({
  fetchVendorObjects: id => dispatch(fetchVendorObjects(id)),
  activeVendorsAdd: id => dispatch(activeVendorsAdd(id))
})

export default connect(mapStateToProps, mapDispatchToProps)(RenderLayers)
